// Alert source tabs for the Fraud Alerts hub. All four agencies read from the
// shared ic3_alerts table (source column) via /bff/ic3/alerts?source=...
export const ALERT_SOURCES = [
  { id: 'ic3', label: 'FBI / IC3' },
  { id: 'ssa', label: 'SSA' },
  { id: 'irs', label: 'IRS' },
  { id: 'ftc', label: 'FTC' },
];

export const SOURCE_LABELS = Object.fromEntries(ALERT_SOURCES.map((s) => [s.id, s.label]));

export const alertsEndpoint = (source) => `/bff/ic3/alerts?limit=50&source=${source}`;
